// extracted by mini-css-extract-plugin
export default {"formContainer":"PasswordReset_formContainer__x31WU","form":"PasswordReset_form__lYEwx","label":"PasswordReset_label__2n0FA","required":"PasswordReset_required__yjmUd"};